const scope = 'app.components.HouseWithResident';

export const TALK_TO_TENANT = `${scope}.TALK_TO_TENANT`;
export const TALK_TO_TENANT_DIALOG = `${scope}.TALK_TO_TENANT_DIALOG`;
